import DashboardItem from "./DashboardItem";

export default function ({projectCount,
                             planCount,
                             checkCount,
                             compareCount,
                             checkMessageCount,
                             compareMessageCount}) {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    flexWrap: 'wrap'
                }}
            >
                <DashboardItem
                    text={'Project Uploads'}
                    value={projectCount}
                />
                <DashboardItem
                    text={'Plan Uploads'}
                    value={planCount}
                />
                <DashboardItem
                    text={'Total Checks'}
                    value={checkCount}
                />
                <DashboardItem
                    text={'Total Comparisons'}
                    value={compareCount}
                />
                <DashboardItem
                    text={'Total Messages'}
                    value={checkMessageCount+compareMessageCount}
                />
            </div>
        </>
    )
}